<template>
  <div class="">
    <div class="row">
      <div class="col-12 col-md-5">
        <documents-send-mail-form
          :documentData="salesOrder"
          :dispatchUrl="'salesOrders/sendMail'"
          :toggleMailModal="toggleMailModal"
          :mailInformation="mailInformation"
        />
      </div>
      <div
        class="col-12 col-md-7"
        style="max-height: 550px; overflow-y: scroll"
      >
        <sales-order-view-details
          :showHeader="false"
          :salesOrder="salesOrder"
          @salesOrderItemsUpdated="get"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button type="danger" @click="toggleMailModal">
        {{ $t("COMMON.CANCEL") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import "flatpickr/dist/flatpickr.css";
import formMixin from "@/mixins/form-mixin";
import salesOrderViewDetails from "./SalesOrderViewDetails.vue";
import DocumentsSendMailForm from "@/components/DocumentsSendMailForm";

export default {
  layout: "DashboardLayout",
  name: "sales-order-mail-modal-content",

  components: {
    DocumentsSendMailForm,
    [Button.name]: Button,
    salesOrderViewDetails,
  },

  mixins: [formMixin],
  props: {
    salesOrder: {
      default: () => {},
    },
    toggleMailModal: {
      type: Function,
    },
    get: {
      type: Function,
    },
    loading: {
      default: () => true,
    },
  },

  data() {
    return {
      submitting: false,
      mailInformation: {
        organization: {},
        recipient: {},
        user: {},
      },
    };
  },

  created() {},

  mounted() {
    this.mailInformation = {
      organization: this.salesOrder?.organization,
      subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_ORDER", {
        organization: this.salesOrder?.organization?.name,
        code: this.salesOrder.code,
      }),
      recipient: {
        username: this.salesOrder?.recipient?.customer_name,
        email: this.salesOrder?.recipient?.email,
      },
    };
  },

  methods: {},

  watch: {
    salesOrder(salesOrder) {
      this.mailInformation = {
        organization: salesOrder.organization,
        subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_ORDER", {
          organization: salesOrder.organization?.name,
          code: salesOrder.code,
        }),
        recipient: {
          username: salesOrder?.recipient?.customer_name,
          email: salesOrder?.recipient?.email,
        },
      };
    },
  },
};
</script>
